import React, { useState, useEffect } from 'react';
import { firestore, collection, getDocs, query, orderBy } from './firebase-config';
import { Link } from 'react-router-dom';
import './BlogList.css';

// Strip HTML tags and return plain text preview
const getPreview = (html, maxLength = 160) => {
  const div = document.createElement('div');
  div.innerHTML = html.replace(/<h[1-6][^>]*>.*?<\/h[1-6]>/gi, '');
  const text = div.textContent || div.innerText || '';
  return text.trim().slice(0, maxLength).trimEnd();
};

const BlogList = () => {
  const [posts, setPosts] = useState([]);
  const [categoryFilter, setCategoryFilter] = useState('All');

  useEffect(() => {
    const fetchPosts = async () => {
      const postsCollection = collection(firestore, 'savedclay_posts');
      const postsQuery = query(postsCollection, orderBy('createdAt', 'desc'));
      const postsSnapshot = await getDocs(postsQuery);
      const postsList = postsSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setPosts(postsList);
    };
    fetchPosts();
  }, []);

  const formatDate = (timestamp) => {
    if (!timestamp) return '';
    const date = timestamp.toDate();
    return date.toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' });
  };

  // Parse comma-separated categories from each post
  const getPostCategories = (post) =>
    (post.category || '').split(',').map(c => c.trim()).filter(Boolean);

  const filteredPosts = categoryFilter === 'All'
    ? posts
    : posts.filter(post => getPostCategories(post).includes(categoryFilter));

  // Build unique category list across all posts
  const allCategories = new Set();
  posts.forEach(post => getPostCategories(post).forEach(c => allCategories.add(c)));
  const categories = ['All', ...Array.from(allCategories).sort()];

  return (
    <div className="blog-list">
      <h1>Blog Posts</h1>
      <div className="category-filter">
        <label htmlFor="category">Filter by Category: </label>
        <select id="category" value={categoryFilter} onChange={(e) => setCategoryFilter(e.target.value)}>
          {categories.map(category => (
            <option key={category} value={category}>{category}</option>
          ))}
        </select>
      </div>
      <ul>
        {filteredPosts.map(post => {
          const preview = getPreview(post.content);
          const hasMore = (post.content || '').replace(/<[^>]+>/g, '').trim().length > 160;
          return (
            <li key={post.id} className="blog-card">
              {post.coverImage && (
                <img src={post.coverImage} alt={post.title} className="blog-card-thumb" />
              )}
              <div className="blog-card-body">
                <p className="blog-card-meta">
                  {getPostCategories(post).join(', ') || 'Uncategorized'} · {formatDate(post.createdAt)}
                </p>
                <h2 className="blog-card-title">
                  <Link to={`/post/${post.id}`}>{post.title}</Link>
                </h2>
                <p className="blog-card-preview">
                  {preview}{hasMore ? '…' : ''}
                </p>
                <Link to={`/post/${post.id}`} className="read-more">Read more →</Link>
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default BlogList;
